import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router, UrlTree } from '@angular/router';

@Pipe({ name: 'replaceLinkInTranslation', standalone: true })
export class ReplaceLinkInTranslationPipe implements PipeTransform {
  readonly linkPlaceholder = '__LINK__';

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {}

  transform(translatedText: string, ...args: [unknown[] | string, boolean]): SafeHtml {
    const [route, useRouter] = args;
    const firstMatch = translatedText.indexOf(this.linkPlaceholder);
    if (firstMatch === -1) {
      return translatedText;
    }

    const beforePlaceholder = translatedText.substring(0, firstMatch);
    const afterPlaceholder = translatedText.substring(firstMatch + this.linkPlaceholder.length);
    const url = useRouter ? this.createUrlTree(route) : route;

    return this.sanitizer.bypassSecurityTrustHtml(beforePlaceholder + url + afterPlaceholder);
  }

  private createUrlTree(route: string | unknown[]): UrlTree {
    return this.router.createUrlTree(Array.isArray(route) ? route : [route]);
  }
}
